<template>
  <tr v-if="loading" class="loading-row">
    <td :colspan="colspan">
      <v-progress-linear
        indeterminate
        color="#6ec39b"
        height="3"
      ></v-progress-linear>
    </td>
  </tr>
</template>

<script>
// Indeterminate loading row for documents tables. Drop into the first slot
// inside `<tbody>`; the row collapses to zero padding/border so the bar
// sits flush against the header's bottom divider.
export default {
  name: "TableLoadingOverlay",
  props: {
    loading: { type: Boolean, default: false },
    colspan: { type: Number, default: 99 },
  },
};
</script>

<style scoped>
.loading-row td {
  padding: 0 !important;
  border: 0 !important;
  height: 3px !important;
  line-height: 0;
  vertical-align: top;
}

.loading-row ::v-deep .v-progress-linear {
  margin: 0 !important;
}
</style>
